import { useAppSelector } from "../../../../store/reduxHooks";
import { SELECT_REQUEST_BANK_ID } from "../../../../store/selectors/requestAppSelector";
import { ApplicationStatusBaseInfo } from "../../../Ui/Application/ApplicationStatusBaseInfo/ApplicationStatusBaseInfo";
import React from "react";
export const BankBaseInfoStatus = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);

  return (
    <ApplicationStatusBaseInfo appNumber={data.id} status={data.status.title} />
  );
};
